import { ShortCut } from "../components/DateRangePicker/enum";

export function getShortCutName(shortCut: ShortCut) {
  switch (shortCut) {
    case ShortCut.TODAY:
      return "Today";
    case ShortCut.YESTERDAY:
      return "Yesterday";
    case ShortCut.THIS_WEEK:
      return "This Week";
    case ShortCut.THIS_MONTH:
      return "This Month";
    case ShortCut.THIS_YEAR:
      return "This Year";
    default:
      return shortCut;
  }
}
